export {
  type LoadMoreSentinelProps,
  useLoadMoreSentinel
} from '../../../src/utils/useLoadMoreSentinel';
